// 简单的消息提示工具函数，替代 element-ui 的 Message
let messageContainer = null;

function createMessageContainer() {
  if (messageContainer) return messageContainer;
  
  messageContainer = document.createElement('div');
  messageContainer.style.cssText = `
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    pointer-events: none;
  `;
  document.body.appendChild(messageContainer);
  return messageContainer;
}

function showMessage(options) {
  const { message, type = 'info', duration = 3000 } = options;
  const container = createMessageContainer();
  
  const messageEl = document.createElement('div');
  messageEl.style.cssText = `
    background: ${type === 'success' ? '#67c23a' : type === 'error' ? '#f56c6c' : '#909399'};
    color: #fff;
    padding: 12px 20px;
    border-radius: 4px;
    margin-bottom: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    font-size: 14px;
    line-height: 1.5;
    min-width: 200px;
    text-align: center;
    pointer-events: auto;
    animation: slideDown 0.3s ease-out;
  `;
  
  // 添加动画样式
  if (!document.getElementById('message-styles')) {
    const style = document.createElement('style');
    style.id = 'message-styles';
    style.textContent = `
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      @keyframes slideUp {
        from {
          opacity: 1;
          transform: translateY(0);
        }
        to {
          opacity: 0;
          transform: translateY(-20px);
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  messageEl.textContent = message;
  container.appendChild(messageEl);
  
  // 自动移除
  const timer = setTimeout(() => {
    messageEl.style.animation = 'slideUp 0.3s ease-out';
    setTimeout(() => {
      if (messageEl.parentNode) {
        messageEl.parentNode.removeChild(messageEl);
      }
    }, 300);
  }, duration);
  
  // 点击关闭
  messageEl.addEventListener('click', () => {
    clearTimeout(timer);
    messageEl.style.animation = 'slideUp 0.3s ease-out';
    setTimeout(() => {
      if (messageEl.parentNode) {
        messageEl.parentNode.removeChild(messageEl);
      }
    }, 300);
  });
}

export default {
  success(options) {
    if (typeof options === 'string') {
      showMessage({ message: options, type: 'success' });
    } else {
      showMessage({ ...options, type: 'success' });
    }
  },
  error(options) {
    if (typeof options === 'string') {
      showMessage({ message: options, type: 'error' });
    } else {
      showMessage({ ...options, type: 'error' });
    }
  },
  info(options) {
    if (typeof options === 'string') {
      showMessage({ message: options, type: 'info' });
    } else {
      showMessage({ ...options, type: 'info' });
    }
  },
  warning(options) {
    if (typeof options === 'string') {
      showMessage({ message: options, type: 'warning' });
    } else {
      showMessage({ ...options, type: 'warning' });
    }
  }
};

// 兼容 element-ui 的调用方式
export function Message(options) {
  if (typeof options === 'string') {
    showMessage({ message: options });
  } else {
    showMessage(options);
  }
}
